import { ChartEntry } from '@views/pages/Dashboard/types';
import { buildGradientColors } from '../../util';

interface IUseDonutChartProps {
  entries: ChartEntry[];
  startColor: string;
  endColor: string;
  otherThreshold: number;
  preserveOrder: boolean;
}

export const useDonutChart = ({
  entries,
  startColor,
  endColor,
  otherThreshold,
  preserveOrder,
}: IUseDonutChartProps) => {
  const totalValue = entries.reduce((prev, curr) => prev + curr.value, 0);

  const sortedEntries = preserveOrder
    ? entries
    : entries.toSorted((a, b) => (a.value < b.value ? 1 : -1));

  const highestEntries = sortedEntries.slice(0, otherThreshold - 1);

  const otherEntry = sortedEntries.slice(otherThreshold - 1).reduce(
    (prev, curr) => {
      if (prev.details) {
        prev.details.push({
          ...curr,
          percentage: `${((100 * curr.value) / totalValue).toFixed(1)}%`,
        });
      }
      return {
        ...prev,
        value: prev.value + curr.value,
      };
    },
    { label: 'Low complexity DYAD', value: 0, details: [] },
  );

  const withOther = [...highestEntries, otherEntry];
  const finalEntries = withOther.filter(
    entry =>
      !(entry.details?.length === 0 && entry.label === 'Low complexity DYAD'),
  );

  const colors = buildGradientColors(finalEntries.length, startColor, endColor);

  return {
    colors,
    finalEntries,
    totalValue,
  };
};
